import { Attributes, useEffect, useState } from 'react';
import { withAfterAppLoaded } from 'src/hoc/withAfterAppLoaded';
import {
  DYNAMIC_MODAL_ACTIONS,
  DYNAMIC_MODAL_VIEWS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { useStore } from 'src/contexts/StoreContext';
import { observer } from 'mobx-react-lite';
import { DynamicModalMap } from '@photosi/rn-components/modals/dynamic-modals/DynamicModal.constants';

export type ErrorViewProps = {
  id: string;
  dynamicModalView: DYNAMIC_MODAL_VIEWS;
  actionCallback: (action: DYNAMIC_MODAL_ACTIONS) => void;
};

const ErrorViewComponent = observer(({ id, dynamicModalView, actionCallback }: ErrorViewProps) => {
  const { isStoreReady, dynamicModal } = useStore();
  const [Renderer, setRenderer] = useState<(typeof DynamicModalMap)[keyof typeof DynamicModalMap] | undefined>(
    undefined,
  );
  const [isShown, setIsShown] = useState(true);

  useEffect(() => {
    if (isStoreReady) {
      setRenderer(undefined);
      dynamicModal.openModal({
        dynamicModalView,
        actionCallback,
      });
    } else if (dynamicModalView in DynamicModalMap) {
      setRenderer(DynamicModalMap[dynamicModalView]);
      setIsShown(true);
    }
  }, []);

  return !!Renderer?.component ? (
    <Renderer.component
      type={Renderer.type}
      dynamicModalLayer={
        {
          id,
          actionCallback: (action: DYNAMIC_MODAL_ACTIONS) => {
            actionCallback(action);
            setIsShown(false);
          },
        } as any
      }
      dynamicModalVisible={isShown}
    />
  ) : (
    <></>
  );
});

export const ErrorView = withAfterAppLoaded<ErrorViewProps & Attributes>(ErrorViewComponent);
